import { Button } from "@/components/ui/button";
import { LogOut, Save } from "lucide-react";

interface ProfileActionsProps {
  isEditing: boolean;
  onSave: () => void;
  onEdit: () => void;
  onSignOut: () => void;
}

export const ProfileActions = ({
  isEditing,
  onSave,
  onEdit,
  onSignOut
}: ProfileActionsProps) => {
  return (
    <div className="flex flex-col gap-2 pt-4">
      {isEditing ? (
        <Button onClick={onSave}>
          <Save className="mr-2 h-4 w-4" />
          Save Changes
        </Button>
      ) : (
        <Button onClick={onEdit}>
          Edit Profile
        </Button>
      )}
      <Button 
        variant="destructive"
        onClick={onSignOut}
      >
        <LogOut className="mr-2 h-4 w-4" />
        Sign Out
      </Button>
    </div>
  );
};